<template>
  <div>
    <div class="grid-x grid-padding-x grid-padding-y">
      
      <div class="cell large-8">
        <div class="grid-x grid-padding-x">
          <div class="small-3 large-3 cell">
            <label for="surname" class="text-right middle">Last Name</label>
          </div>
          <div class="small-9 cell">
            <input type="text" id="surname" v-model="model.lastName" required
            :disabled="loading" />
            <span class="form-error">
              This field is required.
            </span>
          </div>

          <div class="small-3 large-3 cell">
            <label for="name" class="text-right middle">First Name</label>
          </div>
          <div class="small-9 cell">
            <input type="text" id="name" v-model="model.firstName" required
            :disabled="loading" />
            <span class="form-error">
              This field is required.
            </span>
          </div>

          <div class="small-3 large-3 cell">
            <label for="email" class="text-right middle">Email</label>
          </div>
          <div class="small-9 cell">
            <input
              type="email"
              id="email"
              v-model="model.email"
              required
              readonly
              disabled
            />
          </div>

          <div class="small-3 large-3 cell">
            <label for="email" class="text-right middle"></label>
          </div>
          <div class="small-9 cell">
            <button class="button radius" ref="submit" @click="onSubmit">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/app/event-bus'
import userInfoService from "@/app.user/services/main-service.js";

export default {

  name: "userProfile",
  data() {
    return {
      model: {},

      initialized: false,
      loading: true,
      errored: false,
    };
  },
  mounted() {},
  created () {
    this.model = userInfoService.getCurrentUserInfo();
    //loaded
    this.initialized = true; 
    this.loading = false;
  },
  methods: {
    async onSubmit() {
      //let self = this;
      let submitBtn =  this.$refs.submit;
      
      try {
        this.loading=true;
        submitBtn.disabled = true;

        const {data} = await userInfoService.update(this.model);

        this.model.lastName = data.lastName;
        this.model.firstName = data.firstName;
        userInfoService.setUserInfo(this.model);

        EventBus.$emit("refreshUserInfo");
      } catch (error) {
        this.errored = true;
        console.error(error);
      } finally {
        this.loading = false;
        submitBtn.disabled = false;
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";
</style>
